import React, { FC } from 'react'
import { useHistory } from 'react-router'

import {
  useGetNewNotificationsCount,
  routes,
  useFlag,
} from '@sketch/modules-common'

// Icons
import { icons } from './icons'

// Components
import { Dropdown, SelectDropdownLinkItem } from '@sketch/components'
import UserNavbarSection from 'modules/user/components/UserNavbarSection'

// Local Components
import HelpMenu from './components/HelpMenu'

// Styles
import {
  NoWorkspacesAvatar,
  NoWorkspacesDropdown,
  NoWorkspacesIcon,
  NoWorkspacesTitle,
} from './NoWorkspaceSidebar.styles'

import {
  SidebarWrapper,
  MenuWrapper,
  StyledPill,
  WorkspaceSelectorWrapper,
  FooterWrapper,
} from './Sidebar.styles'

// Types
import { useGetInitialUserQuery } from '@sketch/gql-types'

// Helpers
import { menuItemsText } from './menuItems'
import BottomMenu from './components/BottomMenu/BottomMenu'

export const NoWorkspaceSidebar: FC = () => {
  // TODO: Remove updates-page-revamp FF
  // https://github.com/sketch-hq/Cloud/issues/17965
  const isUpdatesPageRevampFFEnabled = useFlag('updates-page-revamp')
  const history = useHistory()
  const { data: userData } = useGetInitialUserQuery()

  const newNotificationsCount = useGetNewNotificationsCount()
  const hasNewNotifications = newNotificationsCount > 0

  const isPartner = userData?.me.isPartner

  return (
    <SidebarWrapper>
      <WorkspaceSelectorWrapper>
        <NoWorkspacesDropdown
          isPartner={isPartner}
          onClick={() => {
            if (!isPartner) {
              history.push(routes.WORKSPACE_CREATE.create({}))
            }
          }}
        >
          <NoWorkspacesAvatar />
          <NoWorkspacesTitle>No Workspaces</NoWorkspacesTitle>
          <NoWorkspacesIcon>
            <Dropdown.Chevrons />
          </NoWorkspacesIcon>
        </NoWorkspacesDropdown>
      </WorkspaceSelectorWrapper>
      <MenuWrapper>
        <SelectDropdownLinkItem
          icon={icons.BellIcon}
          text={menuItemsText.updates}
          to={
            isUpdatesPageRevampFFEnabled
              ? routes.UPDATES_UNREAD.create({})
              : routes.UPDATES.create({})
          }
          additional={
            hasNewNotifications && (
              <StyledPill variant="secondary">New</StyledPill>
            )
          }
        />
        <HelpMenu />
      </MenuWrapper>
      <FooterWrapper>
        <BottomMenu />
        <UserNavbarSection />
      </FooterWrapper>
    </SidebarWrapper>
  )
}
